import React, { useState } from "react";
import APP_CONFIG from "../../config";
import { axiosPublic } from "../../axios";
import { maintenanceFallback } from "../../pages/maintenance/maintenanceFallback";
import "./newsletterforms.css";

const NewsletterForms = ({ userdIn = "normal", endpoint = null, onSuccess = null, model = null }) => {
  const newsletterData = maintenanceFallback?.newsletter || {};

// Sélectionner les clés selon le mode (normal / in_maintenance)
  const suffix =
      userdIn === "in_maintenance" || userdIn === "inmaintenance"
          ? "_in_maintenance"
          : "";


  const cta_title = newsletterData[`cta_title${suffix}`] || "Abonnez-vous";
  const cta_description = newsletterData[`cta_description${suffix}`] || "";
  const title = newsletterData[`title${suffix}`] || "Newsletter";
  const description = newsletterData[`description${suffix}`] || "";
  const button_submit_text = newsletterData[`button_submit_text${suffix}`] || "S'abonner";
  const placeholder = newsletterData[`placeholder${suffix}`] || "Votre adresse email";
  const success_message = newsletterData[`success_message${suffix}`] || "Inscription réussie.";
  const error_message = newsletterData[`error_message${suffix}`] || "Erreur lors de l'inscription.";

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const validateEmail = (value) => {
    if (!value) return false;
    const re = /^\S+@\S+\.\S+$/;
    return re.test(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setStatus(null);

    if (!validateEmail(email)) {
      setError("Veuillez saisir une adresse email valide.");
      return;
    }

    setLoading(true);
    try {
      await axiosPublic.get("/sanctum/csrf-cookie");

      const url =
          endpoint || APP_CONFIG.NEWSLETTER_ENDPOINT || "/api/newsletter/subscribe";

      const response = await axiosPublic.post(url, {
        email: email.trim(),
        source: userdIn === "in_maintenance" ? "maintenance_page" : "newsletter_form"
      });

      if (response.status === 200 || response.status === 201) {
        setStatus("ok");
        setEmail("");
        if (typeof onSuccess === "function") onSuccess();
      } else {
        setStatus("error");
        setError(response.data?.message || error_message);
      }
    } catch (err) {
      setStatus("error");
      setError(err.response?.data?.message || error_message);
    } finally {
      setLoading(false);
    }
  };

  const modelPrefix = model ? `${model}-` : "";

  return (
      <section className={`${modelPrefix}final-cta`}>
        <div className="container">
          <h2 className={`${modelPrefix}final-cta-title`}>{cta_title}</h2>
          <p className={`${modelPrefix}final-cta-description`}>{cta_description}</p>

          <div className={`${modelPrefix}newsletter-box`}>
            <h3 className={`${modelPrefix}newsletter-title`}>{title}</h3>
            <p className={`${modelPrefix}newsletter-description`}>{description}</p>

            <form className={`${modelPrefix}newsletter-form`} onSubmit={handleSubmit} noValidate>
              <input
                  type="email"
                  className={`${modelPrefix}newsletter-input`}
                  placeholder={placeholder}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
              />

              <button type="submit" className={`${modelPrefix}btn-primary`} disabled={loading}>
                {loading ? "En cours..." : button_submit_text}
              </button>

              {error && <p className="error-text">{error}</p>}
              {status === "ok" && <p className="success-text">{success_message}</p>}
            </form>
          </div>
        </div>
      </section>
  );
};

export default NewsletterForms;
